// <picture> chooses the WebP <source> when the browser supports WebP; if that file is
// missing (founder shipped only the JPG) the <img> errors. Drop the sources and retry
// the JPG once; return true when a retry was issued, false when the JPG itself failed.
import type { SyntheticEvent } from "react";

export function retryWithoutWebp(e: SyntheticEvent<HTMLImageElement>): boolean {
  const img = e.currentTarget;
  if (img.dataset.webpFallback === "1") return false;
  const pic = img.parentElement;
  const sources = pic?.tagName === "PICTURE" ? Array.from(pic.querySelectorAll("source")) : [];
  if (sources.length === 0) return false;
  img.dataset.webpFallback = "1";
  sources.forEach((s) => s.remove());
  const src = img.getAttribute("src");
  if (src) {
    img.removeAttribute("src");
    img.setAttribute("src", src);
  }
  return true;
}
